import { render, staticRenderFns } from "./Diff.vue?vue&type=template&id=485427f2&"
import script from "./Diff.vue?vue&type=script&lang=js&"
export * from "./Diff.vue?vue&type=script&lang=js&"
import style0 from "./Diff.vue?vue&type=style&index=0&id=485427f2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports